import type { ButtonHTMLAttributes, CSSProperties } from "react";
import { hitArea } from "./hit";
import { BUTTON_RESET, pressClass } from "./press";
import { scaledFont } from "@/styles/scaledFont";

export interface TxtLinkProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  /** The link's copy — always `t('…')`, never a literal. */
  label: string;
  onClick: () => void;
}

/* 05-SHARED.md: `600 14px/20px Quicksand`, `--d-fg-2`. No `--t-*` token is
 * 14/20, so the type is spelled out over `var(--font-body)`. */
const BASE: CSSProperties = {
  ...BUTTON_RESET,
  font: scaledFont("600 14px/20px var(--font-body)"),
  color: "var(--d-fg-2)",
  ...hitArea(20), // 44pt tap area, DUE-419
};

/**
 * The quiet secondary action — "Edit partner", "Skip for now". A `<button>`,
 * not an `<a>`: every one of these runs an in-app action, never a navigation
 * to a URL.
 *
 * Ported from `TxtLink` in
 * `docs/design/handoff/design/templates/friends/friends-screen.jsx`.
 */
export function TxtLink({
  label,
  onClick,
  className,
  style,
  ...rest
}: TxtLinkProps): JSX.Element {
  return (
    <button
      type="button"
      className={pressClass(className)}
      onClick={onClick}
      style={{ ...BASE, ...style }}
      {...rest}
    >
      {label}
    </button>
  );
}

export default TxtLink;
